import {Component, ElementRef, EventEmitter, Input, Output} from '@angular/core';
import {RemaxMarker} from '../../../../../classes/remax-marker';
import {CustomMarker, NguiMap, NguiMapComponent} from '@ngui/map';

@Component({
  selector: 'ngui-map > app-plain-marker',
  templateUrl: './plain-marker.component.html',
  styleUrls: ['./plain-marker.component.scss']
})
export class PlainMarkerComponent extends CustomMarker {
  @Input() marker: RemaxMarker;
  @Input() position: Array<number>;
  @Output() onClickMarker: EventEmitter<RemaxMarker> = new EventEmitter<RemaxMarker>();

  constructor(nguiMapComponent: NguiMapComponent,
              elementRef: ElementRef,
              nguiMap: NguiMap) {
    super(nguiMapComponent, elementRef, nguiMap);
  }
}
